// screens/Authenticated/Layout.tsx
import React, { useEffect, useMemo, useState } from 'react';
import HeaderAdmin from '../Components/Header';
import SideMenu from '../Components/SideMenu/SideMenu';
import Loading from '@components/Loading/Loading';
import SEO from '@components/SEO';
import useRouteLoading from 'src/hooks/useRouteLoading';
import { Styles } from './styles';
import { AuthenticatedTabs } from '@utils/constants';
import { useLocation } from 'react-router-dom';

interface AuthenticatedLayoutProps {
  children: React.ReactNode;
}

const AuthenticatedLayout: React.FC<AuthenticatedLayoutProps> = ({
  children
}) => {
  const location = useLocation();
  const tabFromPath = useMemo<AuthenticatedTabs>(() => {
    const path = location.pathname;
    if (path.includes('/area-do-corretor/arquivos')) {
      return AuthenticatedTabs.ARQUIVOS;
    }
    if (path.includes('/area-do-corretor/configuracoes')) {
      return AuthenticatedTabs.CONFIGURACOES;
    }
    if (path.includes('/area-do-corretor/conta')) {
      return AuthenticatedTabs.CONTA;
    }
    return AuthenticatedTabs.IMOVEIS;
  }, [location.pathname]);

  const [selectedTab, setSelectedTab] =
    useState<AuthenticatedTabs>(tabFromPath);

  useEffect(() => {
    setSelectedTab(tabFromPath);
  }, [tabFromPath]);
  const loading = useRouteLoading();

  if (loading) {
    return <Loading />;
  }

  return (
    <Styles.PageContainer>
      <SEO noIndex />
      <HeaderAdmin selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      <Styles.ContentContainer>
        <Styles.MainContent>
          <SideMenu selectedTab={selectedTab} />
          <Styles.PageContent> {children} </Styles.PageContent>
        </Styles.MainContent>
      </Styles.ContentContainer>
    </Styles.PageContainer>
  );
};

export default AuthenticatedLayout;
